import React from "react";
import Slider from "react-slick";

// Assets
import "~/assets/sass/pages/invest/evaluteDetail.scss";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import darkNewImg from "~/common/components/Images";
import { WarningIcon } from "~/assets/svg/AlertIcon";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const JudgeList = ({
	setCardStep,
	settings,
	judges,
	info,
	setJudges,
	setDataFromJudge,
	setJudgeNumberMaxFive,
	setDataToFinal,
}) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const handleSelectJudge = (idx) => {
		// role=true 가 5개 이상이면 5개 이상 안된다 alert 창 띄우기 : alert 창 필요
		const newData = judges.map((d) => (d.userIdx === idx ? { ...d, role: !d.role } : d));
		const fiveJudges = newData.filter((d) => d.role === true);
		if (fiveJudges.length > 5) {
			setJudgeNumberMaxFive(true);
		} else {
			// role 을 false로 바꿔주기
			setJudges(newData);
		}
	};

	const handleNextStep = () => {
		// role=true 인 애들만 골라내기
		const fiveJudges = judges.filter((d) => d.role === true);
		setDataToFinal(fiveJudges);
		// {role="attend" , userIdx : userIdx} 로 바꿔서 부모 컴포넌트로 보내기
		const newData = fiveJudges.map((d) => ({ role: "attend", userIdx: d.userIdx }));
		setDataFromJudge(newData);
		// next step go
		setCardStep(3);
	};

	return (
		<section className="c__card evaluate-card request">
			<div className="top">
				<h3 className="main">
					{t("pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.main")}
				</h3>
				<div className="sub">
					<p>{t("pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.sub")}</p>
					<button type="button" className="c__tooltip-btn">
						<WarningIcon />
						<div className="c__tooltip">
							{t(
								"pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.tooltip"
							)}
						</div>
					</button>
				</div>
			</div>
			<Slider {...settings} className="vc-carousel">
				{judges.length === 0
					? ""
					: judges.map((d) => {
							if (d.userIdx === info.idx) {
								return (
									<div className={`judge attend`} key={d.idx}>
										<div className="img-wrap">
											<img
												src={
													d.img
														? d.img
														: theme === "dark"
														? darkNewImg
														: lightProfileImg
												}
												alt={t(
													"pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.imageAlt"
												)}
											/>
											{/*<img src={d.img ? d.img : lightProfileImg} alt="심사역 이미지" />*/}
										</div>
										<h5 className={"participant-info"}>{d.name}</h5>
									</div>
								);
							} else {
								return (
									<div
										className={`judge ${d.role ? "attend" : ""}`}
										key={d.idx}
										onClick={() => handleSelectJudge(d.userIdx)}
									>
										<div className="img-wrap">
											<img
												src={
													d.img
														? d.img
														: theme === "dark"
														? darkNewImg
														: lightProfileImg
												}
												alt={t(
													"pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.imageAlt"
												)}
											/>
											{/*<img src={d.img ? d.img : lightProfileImg} alt="심사역 이미지" />*/}
										</div>
										<h5 className={"participant-info"}>{d.name}</h5>
									</div>
								);
							}
					  })}
			</Slider>
			<div className="btn-wrap">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={handleNextStep}
				>
					{t("pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.next")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="gray"
					onClick={() => setCardStep(1)}
				>
					{t("pages.investment.InvestEvalPage.evalRequest.contents.JudgeList.prev")}
				</button>
			</div>
		</section>
	);
};

export default JudgeList;
